export const primaryWorkflowActions = new Set(["submit", "approve", "publish"]);

export function canSaveDraft(actions: readonly string[]) {
  return actions.includes("save");
}

const footerActionOrder = new Map([
  ["request_changes", 0],
  ["withdraw_change_request", 0],
  ["schedule", 1],
  ["archive", 1],
  ["submit", 2],
  ["approve", 2],
  ["publish", 2],
]);

export function footerWorkflowActions(actions: readonly string[]) {
  return actions
    .filter((action) => action !== "save" && action !== "restore")
    .sort(
      (left, right) =>
        (footerActionOrder.get(left) ?? 1) -
        (footerActionOrder.get(right) ?? 1),
    );
}
